// All 95+ Indian Passport Seva Kendras (PSKs) + every state capital + major
// cities. Used by the "Passport Issued At" combobox in AddTraveller forms.
// Source: passportindia.gov.in PSK locator (as of 2026-04). Extend freely.
export const INDIAN_PASSPORT_CITIES = [
  // PSK locations across India (alphabetical)
  'Agartala', 'Agra', 'Ahmedabad', 'Aizawl', 'Ajmer', 'Akola', 'Allahabad',
  'Ambala', 'Amritsar', 'Anand', 'Anantapur', 'Asansol', 'Aurangabad',
  'Bangalore', 'Bareilly', 'Belgaum', 'Bellary', 'Berhampur', 'Bhagalpur',
  'Bhiwandi', 'Bhopal', 'Bhubaneswar', 'Bikaner', 'Bilaspur', 'Calicut',
  'Chandigarh', 'Chennai', 'Coimbatore', 'Cuddalore', 'Cuttack', 'Davangere',
  'Dehradun', 'Delhi', 'Dhanbad', 'Dharamshala', 'Dharwad', 'Dibrugarh',
  'Dimapur', 'Durgapur', 'Erode', 'Faridabad', 'Gandhinagar', 'Gangtok',
  'Gaya', 'Ghaziabad', 'Goa', 'Gorakhpur', 'Gulbarga', 'Guntur', 'Gurgaon',
  'Guwahati', 'Gwalior', 'Haldwani', 'Hisar', 'Hosur', 'Howrah', 'Hubli',
  'Hyderabad', 'Imphal', 'Indore', 'Itanagar', 'Jabalpur', 'Jaipur',
  'Jalandhar', 'Jammu', 'Jamnagar', 'Jamshedpur', 'Jhansi', 'Jodhpur',
  'Jorhat', 'Kakinada', 'Kalyan', 'Kanpur', 'Karnal', 'Kavaratti',
  'Kochi', 'Kohima', 'Kolhapur', 'Kolkata', 'Kollam', 'Kota', 'Kottayam',
  'Kozhikode', 'Kurnool', 'Latur', 'Leh', 'Lucknow', 'Ludhiana', 'Madurai',
  'Malappuram', 'Mangalore', 'Manipal', 'Mathura', 'Meerut', 'Moradabad',
  'Mumbai', 'Muzaffarnagar', 'Muzaffarpur', 'Mysore', 'Nagercoil', 'Nagpur',
  'Nalbari', 'Namakkal', 'Nanded', 'Nashik', 'Nellore', 'Noida', 'Ongole',
  'Palakkad', 'Panaji', 'Panipat', 'Pasighat', 'Patiala', 'Patna',
  'Pondicherry', 'Port Blair', 'Pune', 'Puri', 'Raipur', 'Rajahmundry',
  'Rajkot', 'Ranchi', 'Ratlam', 'Rohtak', 'Rourkela', 'Sagar', 'Saharanpur',
  'Salem', 'Sambalpur', 'Shillong', 'Shimla', 'Siliguri', 'Silvassa',
  'Sitapur', 'Solapur', 'Srinagar', 'Surat', 'Thane', 'Thanjavur',
  'Thiruvananthapuram', 'Thrissur', 'Tinsukia', 'Tirunelveli', 'Tirupati',
  'Tiruppur', 'Tiruvallur', 'Tumkur', 'Udaipur', 'Ujjain', 'Vadodara',
  'Varanasi', 'Vasco da Gama', 'Vellore', 'Vijayawada', 'Visakhapatnam',
  'Warangal', 'Wayanad',
];
